// Độc bản P0 (ITEMS §5.5.1 #1–#3). Thức tỉnh là P1; Tiền Chủ theo cờ.
import type { UniqueDef } from './types';

export const UNIQUES: readonly UniqueDef[] = [
  {
    id: 'unique.fallenLeafSword',
    base: 'base.fallenLeafSword',
    rarity: 'immortal',
    fixedAffixes: ['atkPct', 'dodgeIframe'],
    icon: 'lac-diep-kiem',
    source: 'boss.thachHauCoVien',
    phase: 'P0',
  },
  {
    id: 'unique.coldJadeArmor',
    base: 'base.coldJadeArmor',
    rarity: 'immortal',
    fixedAffixes: ['hpPct', 'res.water', 'killMoveReduce'],
    icon: 'han-ngoc-giap',
    source: 'boss.sonHoMau',
    phase: 'P0',
  },
  {
    id: 'unique.abyssMirror',
    base: 'base.abyssMirror',
    rarity: 'immortal',
    fixedAffixes: ['skillDmg', 'divineSense', 'qiRate'],
    icon: 'tram-uyen-kinh',
    source: 'boss.nhacTruongThanh',
    firstKillGuaranteed: true,
    formerOwnerVariants: [
      { when: 't4_guardian_fate=spared', suffix: 'spared' },
      { when: 't4_guardian_fate=killed', suffix: 'killed' },
    ],
    phase: 'P0',
  },
];

export function uniqueDef(id: string): UniqueDef {
  const d = UNIQUES.find((x) => x.id === id);
  if (!d) throw new RangeError(`unknown unique: ${id}`);
  return d;
}

export function isUniqueId(v: unknown): v is string {
  return typeof v === 'string' && UNIQUES.some((u) => u.id === v);
}
